module.exports = __webpack_public_path__ + "static/media/3-tantsevalnye.cdbb7347.jpg";